export const fetchProducts = (data) => ({
  type: "FETCH_PRODUCTS",
  payload: data,
});
